// Imports
import React from "react";
import App from "./App.jsx";
import { createRoot } from "react-dom/client";

var react_app_wrapper = document.querySelector("#react__app-wrapper");

// Don't run on a non-React page
if (react_app_wrapper !== null) {
  const root = createRoot(react_app_wrapper);
  root.render(
    <>
      {/*<React.StrictMode> */}
      <div className="react__app-content">
        <App />
      </div>
      {/*</React.StrictMode> */}
    </>
  );
}
